@if (footerVisibility()) {
    <footer class="fixedFooter tw-z-10">
        <div class="footer">
            <div class="navigation">
                <div class="navitems tw-flex-col tw-justify-center">
                    @for (
                        footerLink of selfServiceFooterLinks;
                        track footerLink.translationKey
                    ) {
                        <div class="navitem">
                            <button
                                type="button"
                                class="legal-link"
                                (click)="viewLegalNote()">
                                <span class="legal">
                                    {{
                                        footerLink.translationKey | translate
                                    }}</span
                                >
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    </footer>
}
